(function($) {

	function submit_form(e){

		e.preventDefault()

		// Send
		let url = ghostpress_params.ajax_url + '&action=contact_form',
			data = $(this).serializeArray()

		gp_ajax({
			url: url,
			type: 'post',
			dataType: 'json',
			data: data,
			show_loading: true
		})
			.done((response, textStatus, jqXHR) => {
				let success = response.success
				if(!success){
					// Scroll to error notices
					$('html').animate({
						scrollTop: $('.notices').offset().top
					}, 1000);
				}
			})
	}

	$('form.contact-form').off('submit').submit(submit_form)

})(jQuery);